export const ORDER_QUERY_KEY = {
  ORDER: () => ['order']
};
